var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditcourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5015 1.40931C19.2811 0.188926 17.3026 0.188916 16.0821 1.40931L14.3323 3.1591L6.09692 11.3945C5.96342 11.528 5.86872 11.6953 5.82293 11.8784L4.78127 16.0451C4.69252 16.4001 4.79653 16.7756 5.05526 17.0343C5.31399 17.293 5.6895 17.3971 6.04448 17.3083L10.2111 16.2667C10.3943 16.2208 10.5615 16.1261 10.6951 15.9926L18.8706 7.81714L20.6803 6.00745C21.9007 4.78706 21.9007 2.80842 20.6803 1.58803L20.5015 1.40931ZM17.5553 2.88245C17.962 2.47566 18.6216 2.47566 19.0284 2.88245L19.2071 3.06117C19.6139 3.46797 19.6139 4.12752 19.2071 4.53431L18.1483 5.59319L16.5281 3.90965L17.5553 2.88245ZM16.5281 3.90965L18.1483 5.59319L9.426 14.3155L7.22346 14.8661L7.77408 12.6636L16.5281 3.90965ZM2.66683 6.92274C2.66683 6.34745 3.1332 5.88107 3.7085 5.88107H8.91683C9.49214 5.88107 9.9585 5.41471 9.9585 4.83941C9.9585 4.26411 9.49214 3.79774 8.91683 3.79774H3.7085C1.98261 3.79774 0.583496 5.19685 0.583496 6.92274V18.381C0.583496 20.107 1.98261 21.506 3.7085 21.506H15.1668C16.8928 21.506 18.2918 20.107 18.2918 18.381V13.1727C18.2918 12.5975 17.8255 12.131 17.2502 12.131C16.6749 12.131 16.2085 12.5975 16.2085 13.1727V18.381C16.2085 18.9563 15.7421 19.4227 15.1668 19.4227H3.7085C3.1332 19.4227 2.66683 18.9563 2.66683 18.381V6.92274Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditcourse);
export default __webpack_public_path__ + "static/media/edit course.a5904121befbb431697196187087f4ef.svg";
export { ForwardRef as ReactComponent };